export default "__VITE_ASSET__a5e120c3__"